import React from 'react';
import { Link } from 'react-router-dom';
import * as cls from './nav.module.css';
import { ROUTES_PATHS } from '../../../constants';

export const Nav = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const closeNav = React.useCallback(() => {
    setIsOpen(false);
    document.body.style.overflow = '';
  }, []);

  React.useEffect(() => {
    window.addEventListener('nav-close', closeNav);

    return () => {
      window.removeEventListener('nav-close', closeNav);
    };
  }, [closeNav]);

  return (
    <nav>
      <button
        aria-label="Navigation"
        className={`${cls['mobile-button']} ${isOpen ? cls.active : ''}`}
        onClick={() => {
          setIsOpen(!isOpen);
          document.body.style.overflow = isOpen ? '' : 'hidden';
        }}
      >
        <span />
      </button>
      <ul className={cls.menu}>
        <li>
          <Link to={ROUTES_PATHS.AMAZON_SHOP}>For Homes</Link>

          <ul className={cls.submenu}>
            <li>
              <Link to={ROUTES_PATHS.OUR_TECHNOLOGY}>How It Works</Link>
            </li>
            <li>
              <Link to={ROUTES_PATHS.CASE_STUDIES}>Customer Stories</Link>
            </li>
            <li>
              <Link to={ROUTES_PATHS.AMAZON_SHOP}>Shop</Link>
            </li>
            <li>
              <Link to={ROUTES_PATHS.SUPPORT}>FAQs</Link>
            </li>
            <li>
              <Link to={ROUTES_PATHS.SUPPORT_MATERIALS}>Manuals & Guides</Link>
            </li>
          </ul>
        </li>

        <li>
          <Link to={ROUTES_PATHS.OFFER_TO_UTILITIES}>For Utilities</Link>

          <ul className={cls.submenu}>
            <li>
              <Link to={ROUTES_PATHS.OUR_TECHNOLOGY}>Our Technology</Link>
            </li>
            <li>
              <Link to={ROUTES_PATHS.ENERGY_INTELLIGENCE}>
                AI Disaggregation
              </Link>
            </li>
            <li>
              <Link to={ROUTES_PATHS.APIS_AND_INTEGRATIONS}>
                API & Integrations
              </Link>
            </li>
            <li>
              <Link to={ROUTES_PATHS.VOLTAWARE_SENSORS}>Hardware</Link>
            </li>
            <li>
              <Link to={ROUTES_PATHS.CASE_STUDIES}>Case Studies</Link>
            </li>
            <li>
              <Link to={ROUTES_PATHS.REQUEST_A_DEMO}>Book a Demo</Link>
            </li>
          </ul>
        </li>
        <li>
          <Link to={ROUTES_PATHS.SUPPORT}>Support</Link>

          <ul className={cls.submenu}>
            <li>
              <Link to={ROUTES_PATHS.SUPPORT}>FAQs</Link>
            </li>
            <li>
              <Link to={ROUTES_PATHS.SUPPORT_MATERIALS}>Manuals & Guides</Link>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  );
};
